export const WidgetBarPosition = {
    None: 0,
    Top: 1,
    Right: 2,
    Bottom: 3,
    Left: 4
}

export const WidgetTypeMap = {
    "AvailabilityRequestWidget": { code: 1, pretty: "Standortwidget", typeName: 'AvailabilityRequestWidget' },
    "CalendarWidget": { code: 2, pretty: "Kalenderwidget", typeName: 'CalendarWidget' },
    "ChangeWidget": { code: 3, pretty: "Changes/RFCs-Widget", typeName: 'ChangeWidget' },
    "ChartWidget": { code: 4, pretty: "Statistikwidget", typeName: 'ChartWidget' },
    "ContactPersonalWidget": { code: 5, pretty: "Ansprechpartnerwidget", typeName: 'ContactPersonalWidget' },
    "ContractWidget": { code: 6, pretty: "Vertragswidget", typeName: 'ContractWidget' },
    "CustomerWidget": { code: 7, pretty: "Kundenwidget", typeName: 'CustomerWidget' },
    "DocumentWidget": { code: 8, pretty: "Ordnerstrukturwidget", typeName: 'DocumentWidget' },
    "IFrameWidget": { code: 9, pretty: "IFramewidget", typeName: 'IFrameWidget' },
    "IncidentMailWidget": { code: 10, pretty: "Ticketeingangswidget", typeName: 'IncidentMailWidget' },
    "IncidentWidget": { code: 11, pretty: "Ticketwidget", typeName: 'IncidentWidget' },
    "IssueMailWidget": { code: 12, pretty: "Auftragseingangswidget", typeName: 'IssueMailWidget' },
    "IssueWidget": { code: 13, pretty: "Vorgangswidget", typeName: 'IssueWidget' },
    "OfferWidget": { code: 14, pretty: "Angebotswidget", typeName: 'OfferWidget' },
    "ProjectWidget": { code: 15, pretty: "Projektwidget", typeName: 'ProjectWidget' }
};

export class WidgetGridCell {
    row: number;
    column: number;
    blocked: boolean;
}
